import Image1 from '../images/laptop-1.jpg'
import Image2 from '../images/laptop-2.jpeg'
import Image3 from '../images/laptop-3.jpg'
import Image4 from '../images/laptop-4.jpg'
import Image5 from '../images/laptop-5.jpg'
import Image6 from '../images/laptop-6.jpeg'

const productData = [
    {   
        id:1,
        name:"lenovo thinkbook 1",
        price:67500,
        image:Image1,
        proCount:0,
        total:0,
        description:'Lenovo ThinkPad X1 is a Windows 10 Professional laptop with a 14.00-inch display that has a resolution of 1920x1080 pixels. It is powered by a Core i7 processor and it comes with 16GB of RAM. The Lenovo ThinkPad X1 packs 1TB of HDD storage. Graphics are powered by Integrated Intel HD Graphics 4000.'
    },
    {   
        id:2,
        name:"lenovo ideapad ",
        price:98500,
        image:Image3,
        proCount:0,
        total:0,
        description:'Turbocharge your business with the 35.5cms (14) Lenovo ThinkBook 14 Gen 2. This powerful laptop sports up to an 11th Gen Intel® Core™ processor and offers a range of robust storage and memory options.'
    },
    {
        id:3,
        name:"Dell Inspiron 5430 ",
        price:67740,
        image:Image2,
        proCount:0,
        total:0,
        description:'13th Gen Laptop, Intel Core i5-1335U/8GB/1TB SSD/14.0" (35.56CMs) FHD+ WVA AG with Comfortview Support 250 nits/Backlit KB/Windows 11+MSO 21/15 Month McAfee/Platinum Silver/1.59KGs'
    },
    {   
        id:4,
        name:"Apple 2022 MacBook Pro Laptop ",
        price:119990,
        image:Image4,
        proCount:0,
        total:0,
        description:'M2 chip: 33.74 cm (13.3-inch) Retina Display, 8GB RAM, 256GB SSD ​​​Storage, Touch Bar, Backlit Keyboard, FaceTime HD Camera; Silver '
    },
    {   
        id:5,
        name:"HP Envy x360 ",
        price:98999,
        image:Image5,
        proCount:0,
        total:0,
        description:'15T i7-1195G7, 15.6" FHD Touch,16 GB RAM, 1TB SSD, Intel Iris Xe, Windows 11 Pro, Tilt Pen, No Numpad,Silver​​​​​​​'
    },
    {   
        id:6,
        name:"HP Envy x360",
        price:82490,
        image:Image6,
        proCount:0,
        total:0,
        description:'12th Gen Intel Evo i5-1230U, 13.3inch(33.8 cm) WUXGA 400 Nits, Corning Gorilla Glass Multi-Touch Display(8GB RAM/512GB SSD/B&O/Intel Iris Xe Graphics/5MP IR Camera/Alexa/Pen/13-bf0085TU'
    },

  ]
  
  export default productData
  